module.exports = __webpack_public_path__ + "img/mb2t1.ee62823f.png";